export interface DiffRow {
  kind: "add" | "del" | "ctx" | "gap";
  lOld?: number | null;
  lNew?: number | null;
  text: string;
}

export function computeDiff(a: string, b: string): DiffRow[] {
  const aLines = a.split("\n");
  const bLines = b.split("\n");
  const rows: DiffRow[] = [];
  let i = 0;
  let j = 0;
  while (i < aLines.length || j < bLines.length) {
    if (i < aLines.length && j < bLines.length && aLines[i] === bLines[j]) {
      rows.push({ kind: "ctx", lOld: i + 1, lNew: j + 1, text: aLines[i] });
      i++;
      j++;
    } else if (
      j < bLines.length &&
      (i >= aLines.length || aLines[i] !== bLines[j])
    ) {
      if (i < aLines.length && aLines[i] !== bLines[j]) {
        rows.push({ kind: "del", lOld: i + 1, lNew: null, text: aLines[i] });
        rows.push({ kind: "add", lOld: null, lNew: j + 1, text: bLines[j] });
        i++;
        j++;
      } else {
        rows.push({ kind: "add", lOld: null, lNew: j + 1, text: bLines[j] });
        j++;
      }
    } else if (i < aLines.length) {
      rows.push({ kind: "del", lOld: i + 1, lNew: null, text: aLines[i] });
      i++;
    }
  }
  const keep = new Set<number>();
  rows.forEach((r, idx) => {
    if (r.kind !== "ctx") {
      for (
        let k = Math.max(0, idx - 2);
        k <= Math.min(rows.length - 1, idx + 2);
        k++
      ) {
        keep.add(k);
      }
    }
  });
  const compact: DiffRow[] = [];
  let lastKept = -1;
  rows.forEach((r, idx) => {
    if (keep.has(idx)) {
      if (lastKept !== -1 && idx - lastKept > 1) {
        compact.push({ kind: "gap", text: "…" });
      }
      compact.push(r);
      lastKept = idx;
    }
  });
  return compact;
}

export function truncateMsg(s: string, n: number): string {
  return s.length > n ? s.slice(0, n - 1) + "…" : s;
}
